module.exports = __webpack_public_path__ + "img/ao.981d0f6d.svg";